import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Detail from './Detail';
import List from './List';

export default function ChannelsRoutes({ match }) {
  return (
    <Switch>
      <Route exact path={match.url} component={List} />
      <Route path={`${match.url}/:topicId`} component={Detail} />
    </Switch>
  );
}
